import { InjectionToken } from '@angular/core';

export const PHOTON_URL = new InjectionToken<string>('PHOTON_URL', {
  providedIn: 'root',
  factory: () => 'https://photon.komoot.io',
});
